import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';

export const getVisionFourCharts = async(options) => {
  const params = {
    dataInicial: options.initialDate,
    dataFinal: options.endDate,
    agrupar: options.group,
    status: options.status,
    usuariosIds: options.users || '',
  };
  const httpClient = authenticatedHttpClientFactory();
  const response = await httpClient.get(
    `dashboard/graficoRankingServicos?${new URLSearchParams(params).toString()}`,
  );
  const total = response.data.reduce((total, value) => total + value.valor, 0);
  const x = response.data.map((value) => value.valor);
  const y = response.data.map((value) => value.nome);
  return { total, x, y };
};
